const BpoTab = () => {
  return <div>BPO</div>;
};

export default BpoTab;
